import React from 'react';
import PrimarySectionHeader from 'commonComponents/Headers/PrimarySectionHeader/PrimarySectionHeader';
import styles from './Exception.module.scss';

const Exception = ({ data: { header, subheader, text }, photo }) => {
  const headerProps = {
    header,
    subheader,
    anchor: 'exception'
  };
  return ( 
    <section className={ styles.Exception }>
      <PrimarySectionHeader { ...headerProps } />
      <div className={ styles.content }>
        <figure>
          <img src={ photo } alt={ header } />
        </figure>
        <article>
          { text && text.map((item, i) => <p key={ i }>{ item }</p>) }
        </article>
      </div>
    </section>
  );
};
 
export default Exception;